// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import { THColorPicker } from '@Molecules/Inputs/THColorPicker/THColorPicker';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement } from 'react';
import { DividerCustomize } from './WidgetFormCommon/DividerCustomize';

import './CustomizeField.scss';

export const CustomizeField = (): ReactElement => {
    const i = useLocalMessage();

    return (
        <THForm.List name="customize">
            {(fields) => (
                <div className="customize-field">
                    {!!fields.length && <DividerCustomize />}

                    {fields.map(({ key }, index) => (
                        <div className="customize-field__item" key={key}>
                            <THForm.Item
                                name={[index, 'name']}
                                label={i('common.name')}
                                className="customize-field__item__name"
                            >
                                <THInput disabled />
                            </THForm.Item>

                            <THForm.Item
                                name={[index, 'label']}
                                label={i('general.label')}
                                className="customize-field__item__label"
                            >
                                <THInput />
                            </THForm.Item>

                            <THForm.Item
                                name={[index, 'color']}
                                label={i('general.color')}
                                className="customize-field__item__color"
                            >
                                <THColorPicker />
                            </THForm.Item>
                        </div>
                    ))}
                </div>
            )}
        </THForm.List>
    );
};
